export enum EventActionName {
  ViewedPage = "viewed_page",
  ViewedCta = "viewed_cta",
  ClickedCta = "clicked_cta",
  ClosedCta = "closed_cta",
}
